export function parseImageSize(value: string | number | undefined) {
    if (typeof value === "string") return Number(value)
    if (typeof value === "number") return value

    return undefined
}
